import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_GALLERY_STATE, DEFAULT_POI_GALLERY_IND } from "./constants";
import { IGalleryState } from "./interfaces";

const gallerySlice = createSlice({
	name: "gallery",
	initialState: DEFAULT_GALLERY_STATE,
	reducers: {
		setPoiGallery: (state: IGalleryState, action: PayloadAction<Pick<IGalleryState, "poiGallery" | "poiGalleryInd">>) => {
			state.poiGallery = action.payload.poiGallery;
			state.poiGalleryInd = action.payload.poiGalleryInd;
		},
		clearPoiGallery: (state: IGalleryState) => {
			state.poiGallery = [];
			state.poiGalleryInd = DEFAULT_POI_GALLERY_IND;
		},
	},
});

export const { setPoiGallery, clearPoiGallery } = gallerySlice.actions;
export default gallerySlice.reducer;
